import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { AppComponent } from './app.component';
import { DummyComponent } from './dummy.component';

export const AppRoutes: ModuleWithProviders<any> = RouterModule.forRoot([{
    path: 'app',
    component: AppComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
        {
            path: '',
            children: [
                { path: '', redirectTo: '/app/main/dashboard', pathMatch: 'full' }
            ]
        },
        { path: 'dummy', component: DummyComponent },
        {
            path: 'main',
            loadChildren: () => import('../app/main/main.module').then(m => m.MainModule)
        },
        {
            path: 'admin',
            loadChildren: () => import('../app/admin/admin.module').then(m => m.AdminModule)
        },
        {
            path: 'chatrooms',
            loadChildren: () => import('../app/chatrooms/chatrooms.module').then(m => m.ChatRoomsModule)
        },
        {
            path: 'catalogs',
            loadChildren: () => import('../app/catalogs/catalogs.module').then(m => m.CatalogsModule)
        },
        {
            path: 'procesos',
            loadChildren: () => import('../app/procesos/procesos.module').then(m => m.ProcesosModule)
        },
        {
            path: 'reports',
            loadChildren: () => import('../app/reports/report.module').then(m => m.ReportModule)
        }
    ]
}]);
